import AilabAssistantAPI from 'dashboard/api/ailab/assistant';
import { createStore } from './storeFactory';

export default createStore({
  name: 'AilabAssistant',
  API: AilabAssistantAPI,
});
